<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div v-if="role === 'SuperAdministrador'">
                <AccessibleElSelect
                  v-model="form.distribuidor.value"
                  prop="distribuidor"
                  :options="distribuidoresForAccessibleSelect"
                  :withFormItem="true"
                  id-prefix="rulesfilter"
                  @select="handleSelectDistribuidor"
                >
                  <template slot="label">{{$t('distributors.distributor')}}</template>
                </AccessibleElSelect>
              </div>

              <AccessibleElSelect
                v-model="form.empresa.value"
                prop="empresa"
                :options="clientesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesfilter"
                @select="handleSelectCliente"
                @change="handleChangeCliente"
              >
                <template slot="label">{{$t('app.client')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.name')}}
                <el-form-item prop="name">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.name.value"
                    maxlength="50"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.prioridad')}}
                <el-form-item prop="prioridad">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.prioridad.value"
                    min="0"
                    max="9999999999"
                    type="number"
                  />
                </el-form-item>
              </label>
            </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.activo.value"
                prop="activo"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesfilteractivo"
              >
                <template slot="label">{{$t('companies.active')}}</template>
              </AccessibleElSelect>
            </div>

             <div>
              <AccessibleElSelect
                v-model="form.DetenerEjecucion.value"
                prop="DetenerEjecucion"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesfilterDetenerEjecucion"
              >
                <template slot="label">{{$t('groups.detener_ejecucion')}}</template>
              </AccessibleElSelect>
            </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.MomentoAplicacion.value"
                prop="MomentoAplicacion"
                :options="valuesForMomentoAplicacionReglasForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesfilterMomentoAplicacion"
              >
                <template slot="label">{{$t('rules.tipo_app')}}</template>
              </AccessibleElSelect>
            </div>

             <div>
              <AccessibleElSelect
                v-model="form.automatic_download.value"
                prop="automatic_download"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesfilterautomatic_download"
              >
                <template slot="label">{{$t('companies.automatic_download')}}</template>
              </AccessibleElSelect>
            </div>

             <div>
              <AccessibleElSelect
                v-model="form.estadoDescargaExtra.value"
                prop="estadoDescargaExtra"
                :options="tiposEstadoDescargaForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesfilterestadoDescargaExtra"
              >
                <template slot="label">{{$t('app.estado_destino')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.nombreGrupo.value"
                prop="nombreGrupo"
                :options="gruposForAccessibleSelect"
                :withFormItem="true"
                :group="true"
                id-prefix="rulesfilternombreGrupo"
              >
                <template slot="label">{{$t('notificationFilter.group')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.nombreGrupoPropietario.value"
                prop="nombreGrupoPropietario"
                :options="gruposOwnerForAccessibleSelect"
                :withFormItem="true"
                :group="true"
                id-prefix="rulesfilternombreGrupoPropietario"
              >
                <template slot="label">{{$t('notificationFilter.group_owner')}}</template>
              </AccessibleElSelect>
            </div>

             <div>
              <AccessibleElSelect
                v-model="form.enUso.value"
                prop="enUso"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="rulesfilterenUso"
              >
                <template slot="label">{{$t('tags.used')}}</template>
              </AccessibleElSelect>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import { getGroupsNames } from '@/services/configurations/groups/getGroupsNames'
import { TIPOS_ESTADO_DESCARGA } from '@/config/tipos-estado-descarga'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { TIPOS_MOMENTO_APLICACION_REGLAS_FILTROS } from '@/config/tipos-momento-aplicacion-reglas-filtros'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'rules',
      tiposEstadoDescarga: TIPOS_ESTADO_DESCARGA,
      tiposMomentoAplicacionReglas: TIPOS_MOMENTO_APLICACION_REGLAS_FILTROS,
      isOpen: this.panelOpen,
      links: [],
      form: {
        id: { label: i18n.t('configurations.id'), value: '' },
        name: { label: i18n.t('configurations.name'), value: '' },
        prioridad: { label: i18n.t('configurations.prioridad'), value: '' },
        enUso: { label: i18n.t('tags.used'), value: '' },
        activo: { label: i18n.t('companies.active'), value: '' },
        DetenerEjecucion: { label: i18n.t('groups.detener_ejecucion'), value: '' },
        MomentoAplicacion: { label: i18n.t('rules.tipo_app'), value: '' },
        automatic_download: { label: 'Descarga automática', value: '' },
        estadoDescargaExtra: { label: i18n.t('app.estado_destino'), value: '' },
        nombreGrupo: { label: 'Grupo', value: '' },
        nombreGrupoPropietario: { label: 'GrupoPropietario', value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' }
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
      valuesNombresGrupos: [],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    },
    'form.empresa.value': {
      handler: 'loadGroups'
    }
  },
  mounted: async function () {
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    }

    await this.loadGroups()
  },
  computed: {
    distribuidoresForAccessibleSelect: function () {
      return this.distribuidores.map(item => ({
        id: item.IdDistribuidor,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    clientesForAccessibleSelect: function () {
      return this.clientes.map(item => ({
        id: item.IdEmpresa,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.value,
        name: item.label
      }))
    },
    tiposEstadoDescargaForAccessibleSelect: function () {
      return this.tiposEstadoDescarga.map(item => ({
        id: item.id,
        name: item.Nombre
      }))
    },
    valuesForMomentoAplicacionReglasForAccessibleSelect: function () {
      return this.tiposMomentoAplicacionReglas.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    gruposForAccessibleSelect: function () {
      return this.listaGroupsGrouping.map(group => ({
        label: group.label,
        options: group.options.map(opt => ({ id: opt.value, value: opt.value, name: opt.label }))
      }))
    },
    gruposOwnerForAccessibleSelect: function () {
      return this.listaGroupsGroupingOwner.map(group => ({
        label: group.label,
        options: group.options.map(opt => ({ id: opt.value, value: opt.value, name: opt.label }))
      }))
    },
    listaGroupsGrouping () {
      if (this.valuesNombresGrupos.length > 0) {
        const options = []
        this.valuesNombresGrupos.forEach(x => {
          if (options.filter(y => y.label === x.Tipo).length === 0) {
            options.push(
              { label: x.Tipo, options: [] }
            )
          }
        })
        this.valuesNombresGrupos.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.Tipo)
          options[index].options.push(
            {
              value: x.Nombre,
              label: x.Nombre,
            }
          )
        })
        return options
      }
      return []
    },
    listaGroupsGroupingOwner () {
      return this.listaGroupsGrouping.filter(x => x.label !== 'Reparto')
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
  },
  methods: {
    loadGroups: async function () {
      const cliente = this.clientes.find(c => c.Nombre === this.form.empresa.value)
      const gruposUsuario = await getGroupsNames({ idCliente: cliente?.IdEmpresa })
      if (gruposUsuario.blnError) {
        this.doFeedback(gruposUsuario.msgError + ' [Código de error: ' + gruposUsuario.codError + ']')
      } else {
        this.valuesNombresGrupos = gruposUsuario.Respuesta
      }
    },
    handleChangeCliente: function () {
      const campos = [this.form.nombreGrupo, this.form.nombreGrupoPropietario]
      if (campos.some(campo => campo.value)) {
        campos.forEach(campo => { campo.value = '' })
        this.doFeedback('Se han realizado cambios en el formulario: se han limpiado los filtros de grupo al cambiar el cliente.', 'info', 5000)
      }
    },
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.id.value = _temp.id !== undefined && _temp.id.value !== '' ? _temp.id.value : ''
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.prioridad.value = _temp.prioridad !== undefined && _temp.prioridad.value !== '' ? _temp.prioridad.value : ''
        this.form.enUso.value = _temp.enUso !== undefined && _temp.enUso.value !== '' ? _temp.enUso.value : ''
        this.form.activo.value = _temp.activo !== undefined && _temp.activo.value !== '' ? _temp.activo.value : ''
        this.form.DetenerEjecucion.value = _temp.DetenerEjecucion !== undefined && _temp.DetenerEjecucion.value !== '' ? _temp.DetenerEjecucion.value : ''
        this.form.MomentoAplicacion.value = _temp.MomentoAplicacion !== undefined && _temp.MomentoAplicacion.value !== '' ? _temp.MomentoAplicacion.value : ''
        this.form.automatic_download.value = _temp.automatic_download !== undefined && _temp.automatic_download.value !== '' ? _temp.automatic_download.value : ''
        this.form.estadoDescargaExtra.value = _temp.estadoDescargaExtra !== undefined && _temp.estadoDescargaExtra.value !== '' ? _temp.estadoDescargaExtra.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.nombreGrupo.value = _temp.nombreGrupo !== undefined && _temp.nombreGrupo.value !== '' ? _temp.nombreGrupo.value : ''
        this.form.nombreGrupoPropietario.value = _temp.nombreGrupoPropietario !== undefined && _temp.nombreGrupoPropietario.value !== '' ? _temp.nombreGrupoPropietario.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        id: { label: i18n.t('configurations.id'), value: '' },
        name: { label: i18n.t('configurations.name'), value: '' },
        prioridad: { label: i18n.t('configurations.prioridad'), value: '' },
        enUso: { label: i18n.t('tags.used'), value: '' },
        activo: { label: i18n.t('companies.active'), value: '' },
        DetenerEjecucion: { label: i18n.t('groups.detener_ejecucion'), value: '' },
        MomentoAplicacion: { label: i18n.t('rules.tipo_app'), value: '' },
        automatic_download: { label: 'Descarga automática', value: '' },
        estadoDescargaExtra: { label: i18n.t('app.estado_destino'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        nombreGrupo: { label: 'Grupo', value: '' },
        nombreGrupoPropietario: { label: 'Grupo propietario', value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect: function (item) {
      // console.log(item)
    },
    handleSelectTag: function (item) {
      // console.log('handleSelectTag', item)
      this.form.nombreTag.value = item.id
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    handleSelectRole: function (item) {
      this.form.role.value = item.id
    },
    handleSelectTipoAuth: function (item) {
      this.form.tipoAuth.value = item.id
    }
  }
}
</script>

<style lang="scss" scoped></style>
